module.exports = __webpack_public_path__ + "static/media/dailycandy.0c00b04d.jpg";